import { RecordStatus } from '../../types/menu/enums.types';
import { PermissionLevel, UserPermissionType } from '../../types/public/enum.types';
import { TIME_OFF_WEB_DASH_MODULE_ID } from '../Permissions/employeeTimeOffAdminModule';
import { userPermissionContent } from '../userPermissionContent';

export const employeeModule = {
  'employee-management-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 6,
    featureId: null,
    key: 'employee-management-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'resend-invite-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 6,
    featureId: 17,
    key: 'resend-invite-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'resend-invite-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 6,
    featureId: 17,
    key: 'resend-invite-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'resend-invite-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 6,
    featureId: 17,
    key: 'resend-invite-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'resend-invite-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 6,
    featureId: 17,
    key: 'resend-invite-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'resend-invite-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 6,
    featureId: 17,
    key: 'resend-invite-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'deactivate-employee-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 6,
    featureId: 18,
    key: 'deactivate-employee-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'deactivate-employee-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 6,
    featureId: 18,
    key: 'deactivate-employee-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'deactivate-employee-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 6,
    featureId: 18,
    key: 'deactivate-employee-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'deactivate-employee-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 6,
    featureId: 18,
    key: 'deactivate-employee-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'deactivate-employee-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 6,
    featureId: 18,
    key: 'deactivate-employee-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  're-activate-employee-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 6,
    featureId: 19,
    key: 're-activate-employee-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  're-activate-employee-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 6,
    featureId: 19,
    key: 're-activate-employee-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  're-activate-employee-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 6,
    featureId: 19,
    key: 're-activate-employee-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  're-activate-employee-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 6,
    featureId: 19,
    key: 're-activate-employee-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  're-activate-employee-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 6,
    featureId: 19,
    key: 're-activate-employee-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'personal-information-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 6,
    featureId: 20,
    key: 'personal-information-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'personal-information-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 6,
    featureId: 20,
    key: 'personal-information-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'personal-information-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 6,
    featureId: 20,
    key: 'personal-information-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'personal-information-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 6,
    featureId: 20,
    key: 'personal-information-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'personal-information-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 6,
    featureId: 20,
    key: 'personal-information-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'assigned-roles-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'assigned-roles-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'assigned-roles-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'assigned-roles-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'assigned-roles-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'location-level-access-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'location-level-access-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'location-level-access-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'location-level-access-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'location-level-access-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'documents-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 6,
    featureId: 23,
    key: 'documents-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'documents-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 6,
    featureId: 23,
    key: 'documents-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'documents-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 6,
    featureId: 23,
    key: 'documents-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'documents-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 6,
    featureId: 23,
    key: 'documents-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'documents-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 6,
    featureId: 23,
    key: 'documents-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'employees-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 6,
    featureId: 120,
    key: 'employees-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'employees-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 6,
    featureId: 120,
    key: 'employees-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'employees-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 6,
    featureId: 120,
    key: 'employees-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'employees-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 6,
    featureId: 120,
    key: 'employees-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'employees-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 6,
    featureId: 120,
    key: 'employees-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'details-button-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 6,
    featureId: 121,
    key: 'details-button-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'details-button-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 6,
    featureId: 121,
    key: 'details-button-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'details-button-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 6,
    featureId: 121,
    key: 'details-button-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'details-button-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 6,
    featureId: 121,
    key: 'details-button-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'details-button-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 6,
    featureId: 121,
    key: 'details-button-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
export const myAccountModule = {
  'my-account-visible-module': {
    permissionId: 5,
    appId: 4,
    moduleId: 2,
    featureId: null,
    key: 'my-account-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'my-account-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'my-account-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'my-account-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'my-account-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'my-account-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
export const roleAndPermissionsModule = {
  'roles-permissions-visible-module': {
    permissionId: 5,
    appId: 4,
    moduleId: 7,
    featureId: null,
    key: 'roles-permissions-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },

  'roles-permissions-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 7,
    featureId: 24,
    key: 'roles-permissions-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'roles-permissions-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 7,
    featureId: 24,
    key: 'roles-permissions-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'roles-permissions-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 7,
    featureId: 24,
    key: 'roles-permissions-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'roles-permissions-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 7,
    featureId: 24,
    key: 'roles-permissions-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'roles-permissions-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 7,
    featureId: 24,
    key: 'roles-permissions-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
export const paymentModule = {
  'payments-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 17,
    featureId: null,
    key: 'payments-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'sales-tax-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 17,
    featureId: 97,
    key: 'sales-tax-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'sales-tax-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 17,
    featureId: 97,
    key: 'sales-tax-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'sales-tax-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 17,
    featureId: 97,
    key: 'sales-tax-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'sales-tax-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 17,
    featureId: 97,
    key: 'sales-tax-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'sales-tax-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 17,
    featureId: 97,
    key: 'sales-tax-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'comps-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 17,
    featureId: 98,
    key: 'comps-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'comps-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 17,
    featureId: 98,
    key: 'comps-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'comps-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 17,
    featureId: 98,
    key: 'comps-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'comps-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 17,
    featureId: 98,
    key: 'comps-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'comps-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 17,
    featureId: 98,
    key: 'comps-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'service-charge-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 17,
    featureId: 99,
    key: 'service-charge-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'service-charge-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 17,
    featureId: 99,
    key: 'service-charge-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'service-charge-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 17,
    featureId: 99,
    key: 'service-charge-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'service-charge-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 17,
    featureId: 99,
    key: 'service-charge-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'service-charge-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 17,
    featureId: 99,
    key: 'service-charge-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'tenders-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 17,
    featureId: 134,
    key: 'tenders-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'tenders-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 17,
    featureId: 134,
    key: 'tenders-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'tenders-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 17,
    featureId: 134,
    key: 'tenders-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'tenders-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 17,
    featureId: 134,
    key: 'tenders-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'tenders-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 17,
    featureId: 134,
    key: 'tenders-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'cash-drawer-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 17,
    featureId: 146,
    key: 'cash-drawer-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'cash-drawer-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 17,
    featureId: 146,
    key: 'cash-drawer-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'cash-drawer-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 17,
    featureId: 146,
    key: 'cash-drawer-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'cash-drawer-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 17,
    featureId: 146,
    key: 'cash-drawer-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'cash-drawer-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 17,
    featureId: 146,
    key: 'cash-drawer-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
export const menuManagerModule = {
  'menu-manager-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 27,
    featureId: null,
    key: 'menu-manager-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'menu-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 27,
    featureId: 90,
    key: 'menu-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'menu-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 27,
    featureId: 90,
    key: 'menu-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'menu-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 90,
    key: 'menu-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'menu-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 90,
    key: 'menu-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'menu-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 27,
    featureId: 90,
    key: 'menu-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'category-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 27,
    featureId: 91,
    key: 'category-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'category-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 27,
    featureId: 91,
    key: 'category-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'category-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 91,
    key: 'category-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'category-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 91,
    key: 'category-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'category-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 27,
    featureId: 91,
    key: 'category-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'Item-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 27,
    featureId: 92,
    key: 'Item-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'Item-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 27,
    featureId: 92,
    key: 'Item-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'Item-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 92,
    key: 'Item-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'Item-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 92,
    key: 'Item-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'Item-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 27,
    featureId: 92,
    key: 'Item-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'modifier-group-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 27,
    featureId: 93,
    key: 'modifier-group-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'modifier-group-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 27,
    featureId: 93,
    key: 'modifier-group-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'modifier-group-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 93,
    key: 'modifier-group-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'modifier-group-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 93,
    key: 'modifier-group-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'modifier-group-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 27,
    featureId: 93,
    key: 'modifier-group-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'modifier-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 27,
    featureId: 94,
    key: 'modifier-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'modifier-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 27,
    featureId: 94,
    key: 'modifier-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'modifier-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 94,
    key: 'modifier-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'modifier-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 94,
    key: 'modifier-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'modifier-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 27,
    featureId: 94,
    key: 'modifier-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'modifier-option-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 27,
    featureId: 95,
    key: 'modifier-option-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'modifier-option-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 27,
    featureId: 95,
    key: 'modifier-option-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'modifier-option-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 95,
    key: 'modifier-option-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'modifier-option-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 95,
    key: 'modifier-option-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'modifier-option-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 27,
    featureId: 95,
    key: 'modifier-option-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'tags-&-allergens-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 27,
    featureId: 96,
    key: 'tags-&-allergens-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'tags-&-allergens-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 27,
    featureId: 96,
    key: 'tags-&-allergens-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'tags-&-allergens-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 96,
    key: 'tags-&-allergens-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'tags-&-allergens-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 96,
    key: 'tags-&-allergens-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'tags-&-allergens-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 27,
    featureId: 96,
    key: 'tags-&-allergens-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
export const marketingModule = {
  'marketing-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 28,
    featureId: null,
    key: 'marketing-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'guestbook-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 28,
    featureId: 100,
    key: 'guestbook-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'guestbook-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 100,
    key: 'guestbook-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'guestbook-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 100,
    key: 'guestbook-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'guestbook-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 100,
    key: 'guestbook-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'guestbook-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 100,
    key: 'guestbook-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'brandbook-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 28,
    featureId: 101,
    key: 'brandbook-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'brandbook-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 101,
    key: 'brandbook-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'brandbook-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 101,
    key: 'brandbook-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'brandbook-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 101,
    key: 'brandbook-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'brandbook-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 101,
    key: 'brandbook-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'deals-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 28,
    featureId: 102,
    key: 'deals-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'deals-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 102,
    key: 'deals-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'deals-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 102,
    key: 'deals-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'deals-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 102,
    key: 'deals-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'deals-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 102,
    key: 'deals-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'website-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 28,
    featureId: 103,
    key: 'website-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'website-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 103,
    key: 'website-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'website-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 103,
    key: 'website-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'website-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 103,
    key: 'website-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'website-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 103,
    key: 'website-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'spotlights-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 28,
    featureId: 104,
    key: 'spotlights-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'spotlights-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 104,
    key: 'spotlights-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'spotlights-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 104,
    key: 'spotlights-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'spotlights-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 104,
    key: 'spotlights-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'spotlights-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 104,
    key: 'spotlights-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'campaigns-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 28,
    featureId: 105,
    key: 'campaigns-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'campaigns-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 105,
    key: 'campaigns-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'campaigns-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 105,
    key: 'campaigns-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'campaigns-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 105,
    key: 'campaigns-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'campaigns-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 105,
    key: 'campaigns-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'journeys-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 28,
    featureId: 106,
    key: 'journeys-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'journeys-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 106,
    key: 'journeys-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'journeys-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 106,
    key: 'journeys-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'journeys-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 106,
    key: 'journeys-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'journeys-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 106,
    key: 'journeys-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'loyalty-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 28,
    featureId: 107,
    key: 'loyalty-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'loyalty-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 107,
    key: 'loyalty-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'loyalty-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 107,
    key: 'loyalty-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'loyalty-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 107,
    key: 'loyalty-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'loyalty-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 107,
    key: 'loyalty-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'dashboard-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 28,
    featureId: 108,
    key: 'dashboard-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'dashboard-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 108,
    key: 'dashboard-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'dashboard-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 108,
    key: 'dashboard-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'dashboard-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 108,
    key: 'dashboard-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'dashboard-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 108,
    key: 'dashboard-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'gift-cards-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 28,
    featureId: 109,
    key: 'gift-cards-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'gift-cards-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 109,
    key: 'gift-cards-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'gift-cards-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 109,
    key: 'gift-cards-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'gift-cards-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 109,
    key: 'gift-cards-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'gift-cards-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 109,
    key: 'gift-cards-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'guest-segments-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 28,
    featureId: 139,
    key: 'guest-segments-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'guest-segments-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 139,
    key: 'guest-segments-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'guest-segments-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 139,
    key: 'guest-segments-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'guest-segments-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 139,
    key: 'guest-segments-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'guest-segments-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 139,
    key: 'guest-segments-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'guest-spend-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 28,
    featureId: 140,
    key: 'guest-spend-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'guest-spend-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 140,
    key: 'guest-spend-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'guest-spend-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 140,
    key: 'guest-spend-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'guest-spend-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 140,
    key: 'guest-spend-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'guest-spend-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 140,
    key: 'guest-spend-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'review-management-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 28,
    featureId: 142,
    key: 'review-management-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'review-management-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 142,
    key: 'review-management-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'review-management-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 142,
    key: 'review-management-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'review-management-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 142,
    key: 'review-management-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'review-management-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 142,
    key: 'review-management-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
export const inventoryModule = {
  'inventory-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 29,
    featureId: null,
    key: 'inventory-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'ingredients-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 29,
    featureId: 148,
    key: 'ingredients-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'ingredients-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 148,
    key: 'ingredients-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'ingredients-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 148,
    key: 'ingredients-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'ingredients-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 148,
    key: 'ingredients-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'ingredients-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 148,
    key: 'ingredients-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'orders-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 29,
    featureId: 149,
    key: 'orders-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'orders-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 149,
    key: 'orders-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'orders-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 149,
    key: 'orders-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'orders-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 149,
    key: 'orders-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'orders-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 149,
    key: 'orders-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'recipes-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 29,
    featureId: 150,
    key: 'recipes-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'recipes-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 150,
    key: 'recipes-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'recipes-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 150,
    key: 'recipes-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'recipes-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 150,
    key: 'recipes-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'recipes-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 150,
    key: 'recipes-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'invoices-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 29,
    featureId: 151,
    key: 'invoices-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'invoices-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 151,
    key: 'invoices-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'invoices-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 151,
    key: 'invoices-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'invoices-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 151,
    key: 'invoices-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'invoices-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 151,
    key: 'invoices-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'storage-areas-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 29,
    featureId: 152,
    key: 'storage-areas-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'storage-areas-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 152,
    key: 'storage-areas-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'storage-areas-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 152,
    key: 'storage-areas-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'storage-areas-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 152,
    key: 'storage-areas-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'storage-areas-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 152,
    key: 'storage-areas-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'vendors-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 29,
    featureId: 153,
    key: 'vendors-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'vendors-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 153,
    key: 'vendors-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'vendors-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 153,
    key: 'vendors-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'vendors-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 153,
    key: 'vendors-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'vendors-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 153,
    key: 'vendors-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'non-ingredients-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 29,
    featureId: 154,
    key: 'non-ingredients-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'non-ingredients-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 154,
    key: 'non-ingredients-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'non-ingredients-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 154,
    key: 'non-ingredients-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'non-ingredients-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 154,
    key: 'non-ingredients-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'non-ingredients-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 154,
    key: 'non-ingredients-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
export const accountingModule = {
  'accounting-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 30,
    featureId: null,
    key: 'accounting-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'chart-of-accounts-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 30,
    featureId: 161,
    key: 'chart-of-accounts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'chart-of-accounts-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 30,
    featureId: 161,
    key: 'chart-of-accounts-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'chart-of-accounts-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 30,
    featureId: 161,
    key: 'chart-of-accounts-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'chart-of-accounts-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 30,
    featureId: 161,
    key: 'chart-of-accounts-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'chart-of-accounts-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 30,
    featureId: 161,
    key: 'chart-of-accounts-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'bill-payments-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 30,
    featureId: 162,
    key: 'bill-payments-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'bill-payments-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 30,
    featureId: 162,
    key: 'bill-payments-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'bill-payments-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 30,
    featureId: 162,
    key: 'bill-payments-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'bill-payments-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 30,
    featureId: 162,
    key: 'bill-payments-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'bill-payments-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 30,
    featureId: 162,
    key: 'bill-payments-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'journal-entry-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 30,
    featureId: 163,
    key: 'journal-entry-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'journal-entry-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 30,
    featureId: 163,
    key: 'journal-entry-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'journal-entry-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 30,
    featureId: 163,
    key: 'journal-entry-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'journal-entry-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 30,
    featureId: 163,
    key: 'journal-entry-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'journal-entry-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 30,
    featureId: 163,
    key: 'journal-entry-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'reconciliation-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 30,
    featureId: 164,
    key: 'reconciliation-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'reconciliation-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 30,
    featureId: 164,
    key: 'reconciliation-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'reconciliation-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 30,
    featureId: 164,
    key: 'reconciliation-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'reconciliation-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 30,
    featureId: 164,
    key: 'reconciliation-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'reconciliation-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 30,
    featureId: 164,
    key: 'reconciliation-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'sales-controller-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 30,
    featureId: 165,
    key: 'sales-controller-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'sales-controller-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 30,
    featureId: 165,
    key: 'sales-controller-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'sales-controller-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 30,
    featureId: 165,
    key: 'sales-controller-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'sales-controller-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 30,
    featureId: 165,
    key: 'sales-controller-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'sales-controller-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 30,
    featureId: 165,
    key: 'sales-controller-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'financial-statement-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 30,
    featureId: 222,
    key: userPermissionContent.feature.financial_statement_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'financial-statement-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 30,
    featureId: 222,
    key: userPermissionContent.feature.financial_statement_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'financial-statement-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 30,
    featureId: 222,
    key: userPermissionContent.feature.financial_statement_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'financial-statement-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 30,
    featureId: 222,
    key: userPermissionContent.feature.financial_statement_edit,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'financial-statement-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 30,
    featureId: 222,
    key: userPermissionContent.feature.financial_statement_delete,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
export const websiteModule = {
  'website-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 44,
    featureId: null,
    key: 'website-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'website-templates-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 44,
    featureId: 135,
    key: 'website-templates-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'website-templates-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 44,
    featureId: 135,
    key: 'website-templates-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'website-templates-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 44,
    featureId: 135,
    key: 'website-templates-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'website-templates-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 44,
    featureId: 135,
    key: 'website-templates-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'website-templates-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 44,
    featureId: 135,
    key: 'website-templates-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'website-builder-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 44,
    featureId: 136,
    key: 'website-builder-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'website-builder-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 44,
    featureId: 136,
    key: 'website-builder-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'website-builder-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 44,
    featureId: 136,
    key: 'website-builder-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'website-builder-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 44,
    featureId: 136,
    key: 'website-builder-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'website-builder-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 44,
    featureId: 136,
    key: 'website-builder-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'website-seo-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 44,
    featureId: 137,
    key: 'website-seo-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'website-seo-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 44,
    featureId: 137,
    key: 'website-seo-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'website-seo-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 44,
    featureId: 137,
    key: 'website-seo-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'website-seo-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 44,
    featureId: 137,
    key: 'website-seo-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'website-seo-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 44,
    featureId: 137,
    key: 'website-seo-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'website-announcements-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 44,
    featureId: 138,
    key: 'website-announcements-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'website-announcements-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 44,
    featureId: 138,
    key: 'website-announcements-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'website-announcements-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 44,
    featureId: 138,
    key: 'website-announcements-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'website-announcements-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 44,
    featureId: 138,
    key: 'website-announcements-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'website-announcements-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 44,
    featureId: 138,
    key: 'website-announcements-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  //for forms visible create edit read and delete
  'forms-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 44,
    featureId: 208,
    key: 'forms-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'forms-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 44,
    featureId: 208,
    key: 'forms-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'forms-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 44,
    featureId: 208,
    key: 'forms-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'forms-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 44,
    featureId: 208,
    key: 'forms-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'forms-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 44,
    featureId: 208,
    key: 'forms-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  //for overview add create, visibile, edit ,read and delete
  'overview-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 44,
    featureId: 209,
    key: 'overview-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'overview-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 44,
    featureId: 209,
    key: 'overview-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'overview-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 44,
    featureId: 209,
    key: 'overview-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'overview-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 44,
    featureId: 209,
    key: 'overview-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'overview-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 44,
    featureId: 209,
    key: 'overview-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
export const tipsModule = {
  'tips-management-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 54,
    featureId: null,
    key: 'tips-management-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'tips-pooling-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 54,
    featureId: 169,
    key: 'tips-pooling-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'tips-pooling-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 54,
    featureId: 169,
    key: 'tips-pooling-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'tips-pooling-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 54,
    featureId: 169,
    key: 'tips-pooling-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'tips-pooling-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 54,
    featureId: 169,
    key: 'tips-pooling-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'tips-pooling-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 54,
    featureId: 169,
    key: 'tips-pooling-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
export const settingsModule = {
  'settings-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 65,
    featureId: null,
    key: 'settings-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'receipt-settings-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 65,
    featureId: 188,
    key: 'receipt-settings-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'receipt-settings-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 65,
    featureId: 188,
    key: 'receipt-settings-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'receipt-settings-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 65,
    featureId: 188,
    key: 'receipt-settings-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'receipt-settings-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 65,
    featureId: 188,
    key: 'receipt-settings-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'receipt-settings-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 65,
    featureId: 188,
    key: 'receipt-settings-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'business-hours-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 65,
    featureId: 189,
    key: 'business-hours-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'business-hours-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 65,
    featureId: 189,
    key: 'business-hours-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'business-hours-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 65,
    featureId: 189,
    key: 'business-hours-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'business-hours-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 65,
    featureId: 189,
    key: 'business-hours-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'business-hours-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 65,
    featureId: 189,
    key: 'business-hours-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'pos-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 65,
    featureId: 215,
    key: 'pos-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'pos-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 65,
    featureId: 215,
    key: 'pos-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'pos-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 65,
    featureId: 215,
    key: 'pos-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'pos-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 65,
    featureId: 215,
    key: 'pos-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'pos-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 65,
    featureId: 215,
    key: 'pos-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
export const payrollModule = {
  'payroll-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 66,
    featureId: null,
    key: 'payroll-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'onboarding-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 66,
    featureId: 186,
    key: 'onboarding-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'onboarding-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 66,
    featureId: 186,
    key: 'onboarding-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'onboarding-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 66,
    featureId: 186,
    key: 'onboarding-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'onboarding-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 66,
    featureId: 186,
    key: 'onboarding-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'onboarding-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 66,
    featureId: 186,
    key: 'onboarding-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'setup-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 66,
    featureId: 187,
    key: 'setup-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'setup-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 66,
    featureId: 187,
    key: 'setup-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'setup-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 66,
    featureId: 187,
    key: 'setup-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'setup-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 66,
    featureId: 187,
    key: 'setup-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'setup-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 66,
    featureId: 187,
    key: 'setup-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'benefits-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 66,
    featureId: 197,
    key: 'benefits-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'benefits-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 66,
    featureId: 197,
    key: 'benefits-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'benefits-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 66,
    featureId: 197,
    key: 'benefits-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'benefits-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 66,
    featureId: 197,
    key: 'benefits-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'benefits-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 66,
    featureId: 197,
    key: 'benefits-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};

export const integrationModule = {
  'integrations-visible-module': {
    permissionId: 5,
    appId: 4,
    moduleId: 67,
    featureId: null,
    key: 'integrations-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'integrations-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 67,
    featureId: 185,
    key: 'integrations-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'integrations-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 67,
    featureId: 185,
    key: 'integrations-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'integrations-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 67,
    featureId: 185,
    key: 'integrations-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'integrations-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 67,
    featureId: 185,
    key: 'integrations-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'integrations-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 67,
    featureId: 185,
    key: 'integrations-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
export const reportsModulePermission = {
  'reports-visible-module': {
    permissionId: 5,
    appId: 4,
    moduleId: 70,
    featureId: null,
    key: userPermissionContent.feature.reports_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'reports-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 70,
    featureId: 199,
    key: userPermissionContent.feature.reports_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'reports-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 70,
    featureId: 199,
    key: userPermissionContent.feature.reports_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'reports-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 70,
    featureId: 199,
    key: userPermissionContent.feature.reports_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'reports-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 70,
    featureId: 199,
    key: userPermissionContent.feature.reports_edit,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'reports-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 70,
    featureId: 199,
    key: userPermissionContent.feature.reports_delete,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  // create for the Sale Summary
  'sales-summary-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 70,
    featureId: 211,
    key: userPermissionContent.feature.sales_summary_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'sales-summary-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 70,
    featureId: 211,
    key: userPermissionContent.feature.sales_summary_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'sales-summary-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 70,
    featureId: 211,
    key: userPermissionContent.feature.sales_summary_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'sales-summary-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 70,
    featureId: 211,
    key: userPermissionContent.feature.sales_summary_edit,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'sales-summary-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 70,
    featureId: 211,
    key: userPermissionContent.feature.sales_summary_delete,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  // create for the net sales
  'net-sales-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 70,
    featureId: 212,
    key: userPermissionContent.feature.net_sales_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'net-sales-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 70,
    featureId: 212,
    key: userPermissionContent.feature.net_sales_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'net-sales-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 70,
    featureId: 212,
    key: userPermissionContent.feature.net_sales_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'net-sales-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 70,
    featureId: 212,
    key: userPermissionContent.feature.net_sales_edit,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'net-sales-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 70,
    featureId: 212,
    key: userPermissionContent.feature.net_sales_delete,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  //create for the timecards
  'timecards-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 70,
    featureId: 213,
    key: userPermissionContent.feature.timecards_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'timecards-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 70,
    featureId: 213,
    key: userPermissionContent.feature.timecards_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'timecards-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 70,
    featureId: 213,
    key: userPermissionContent.feature.timecards_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'timecards-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 70,
    featureId: 213,
    key: userPermissionContent.feature.timecards_edit,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'timecards-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 70,
    featureId: 213,
    key: userPermissionContent.feature.timecards_delete,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  // create for the payroll history
  'payroll-history-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 70,
    featureId: 214,
    key: userPermissionContent.feature.payroll_history_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'payroll-history-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 70,
    featureId: 214,
    key: userPermissionContent.feature.payroll_history_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'payroll-history-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 70,
    featureId: 214,
    key: userPermissionContent.feature.payroll_history_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'payroll-history-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 70,
    featureId: 214,
    key: userPermissionContent.feature.payroll_history_edit,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'payroll-history-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 70,
    featureId: 214,
    key: userPermissionContent.feature.payroll_history_delete,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  // Labor Cost Report
  'labor-cost-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 70,
    featureId: 223,
    key: userPermissionContent.feature.labor_cost_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'labor-cost-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 70,
    featureId: 223,
    key: userPermissionContent.feature.labor_cost_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  // Overtime Report
  'overtime-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 70,
    featureId: 224,
    key: userPermissionContent.feature.overtime_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'overtime-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 70,
    featureId: 224,
    key: userPermissionContent.feature.overtime_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  // Employee Productivity Report
  'employee-productivity-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 70,
    featureId: 225,
    key: userPermissionContent.feature.employee_productivity_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'employee-productivity-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 70,
    featureId: 225,
    key: userPermissionContent.feature.employee_productivity_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  // Tip Pooling Report (Reports Module - featureId 226)
  // Note: Using unique keys 'tips-pooling-report-visible' and 'tips-pooling-report-read'
  // to distinguish from Tips Management module (featureId 169) which uses 'tips-pooling-visible' and 'tips-pooling-read'
  'tip-pooling-report-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 70,
    featureId: 226,
    key: userPermissionContent.feature.tips_pooling_report_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'tip-pooling-report-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 70,
    featureId: 226,
    key: userPermissionContent.feature.tips_pooling_report_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  // Break Compliance Report
  'break-compliance-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 70,
    featureId: 227,
    key: userPermissionContent.feature.break_compliance_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'break-compliance-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 70,
    featureId: 227,
    key: userPermissionContent.feature.break_compliance_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  // Menu Summary Report
  'menu-summary-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 70,
    featureId: 228,
    key: userPermissionContent.feature.menu_summary_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'menu-summary-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 70,
    featureId: 228,
    key: userPermissionContent.feature.menu_summary_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  // Temporarily hidden - Marketing Reports (2026)
  // // Gift Card Report
  // 'gift-card-visible': {
  //   permissionId: 5,
  //   appId: 4,
  //   moduleId: 70,
  //   featureId: 229,
  //   key: userPermissionContent.feature.gift_card_report_visible,
  //   isGranted: true,
  //   isApprovalNeeded: false,
  //   permissionLevel: PermissionLevel.FEATURE,
  //   type: UserPermissionType.ROLE,
  //   status: RecordStatus.ACTIVE,
  //   createdBy: 'System',
  // },
  // 'gift-card-read': {
  //   permissionId: 4,
  //   appId: 4,
  //   moduleId: 70,
  //   featureId: 229,
  //   key: userPermissionContent.feature.gift_card_report_read,
  //   isGranted: true,
  //   isApprovalNeeded: false,
  //   permissionLevel: PermissionLevel.FEATURE,
  //   type: UserPermissionType.ROLE,
  //   status: RecordStatus.ACTIVE,
  //   createdBy: 'System',
  // },
  // // Loyalty Report
  // 'loyalty-visible': {
  //   permissionId: 5,
  //   appId: 4,
  //   moduleId: 70,
  //   featureId: 230,
  //   key: userPermissionContent.feature.loyalty_report_visible,
  //   isGranted: true,
  //   isApprovalNeeded: false,
  //   permissionLevel: PermissionLevel.FEATURE,
  //   type: UserPermissionType.ROLE,
  //   status: RecordStatus.ACTIVE,
  //   createdBy: 'System',
  // },
  // 'loyalty-read': {
  //   permissionId: 4,
  //   appId: 4,
  //   moduleId: 70,
  //   featureId: 230,
  //   key: userPermissionContent.feature.loyalty_report_read,
  //   isGranted: true,
  //   isApprovalNeeded: false,
  //   permissionLevel: PermissionLevel.FEATURE,
  //   type: UserPermissionType.ROLE,
  //   status: RecordStatus.ACTIVE,
  //   createdBy: 'System',
  // },
  // // Deals Report
  // 'deals-visible': {
  //   permissionId: 5,
  //   appId: 4,
  //   moduleId: 70,
  //   featureId: 231,
  //   key: userPermissionContent.feature.deals_report_visible,
  //   isGranted: true,
  //   isApprovalNeeded: false,
  //   permissionLevel: PermissionLevel.FEATURE,
  //   type: UserPermissionType.ROLE,
  //   status: RecordStatus.ACTIVE,
  //   createdBy: 'System',
  // },
  // 'deals-read': {
  //   permissionId: 4,
  //   appId: 4,
  //   moduleId: 70,
  //   featureId: 231,
  //   key: userPermissionContent.feature.deals_report_read,
  //   isGranted: true,
  //   isApprovalNeeded: false,
  //   permissionLevel: PermissionLevel.FEATURE,
  //   type: UserPermissionType.ROLE,
  //   status: RecordStatus.ACTIVE,
  //   createdBy: 'System',
  // },
  // Payroll Summary Report
  'payroll-summary-report-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 70,
    featureId: 233,
    key: userPermissionContent.feature.payroll_summary_report_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'payroll-summary-report-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 70,
    featureId: 233,
    key: userPermissionContent.feature.payroll_summary_report_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};

// Performance Summary Report permissions - separate object to not affect old migrations
export const performanceSummaryReportModulePermission = {
  'performance-summary-report-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 70,
    featureId: 236,
    key: userPermissionContent.feature.performance_summary_report_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'performance-summary-report-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 70,
    featureId: 236,
    key: userPermissionContent.feature.performance_summary_report_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'performance-summary-report-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 70,
    featureId: 236,
    key: userPermissionContent.feature.performance_summary_report_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'performance-summary-report-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 70,
    featureId: 236,
    key: userPermissionContent.feature.performance_summary_report_edit,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'performance-summary-report-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 70,
    featureId: 236,
    key: userPermissionContent.feature.performance_summary_report_delete,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};

export const employeeTimeOffAdminModulePermission = {
  'time-off-visible-module': {
    permissionId: 5,
    appId: 4,
    moduleId: TIME_OFF_WEB_DASH_MODULE_ID,
    featureId: null,
    key: userPermissionContent.module.time_off,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'time-off-policy-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: TIME_OFF_WEB_DASH_MODULE_ID,
    featureId: 242,
    key: userPermissionContent.feature.time_off_policy_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'time-off-policy-create': {
    permissionId: 1,
    appId: 4,
    moduleId: TIME_OFF_WEB_DASH_MODULE_ID,
    featureId: 242,
    key: userPermissionContent.feature.time_off_policy_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'time-off-policy-read': {
    permissionId: 4,
    appId: 4,
    moduleId: TIME_OFF_WEB_DASH_MODULE_ID,
    featureId: 242,
    key: userPermissionContent.feature.time_off_policy_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'time-off-policy-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: TIME_OFF_WEB_DASH_MODULE_ID,
    featureId: 242,
    key: userPermissionContent.feature.time_off_policy_edit,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'time-off-allocation-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: TIME_OFF_WEB_DASH_MODULE_ID,
    featureId: 243,
    key: userPermissionContent.feature.time_off_allocation_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'time-off-allocation-create': {
    permissionId: 1,
    appId: 4,
    moduleId: TIME_OFF_WEB_DASH_MODULE_ID,
    featureId: 243,
    key: userPermissionContent.feature.time_off_allocation_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'time-off-allocation-read': {
    permissionId: 4,
    appId: 4,
    moduleId: TIME_OFF_WEB_DASH_MODULE_ID,
    featureId: 243,
    key: userPermissionContent.feature.time_off_allocation_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'time-off-allocation-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: TIME_OFF_WEB_DASH_MODULE_ID,
    featureId: 243,
    key: userPermissionContent.feature.time_off_allocation_edit,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'time-off-leave-overview-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: TIME_OFF_WEB_DASH_MODULE_ID,
    featureId: 244,
    key: userPermissionContent.feature.time_off_leave_overview_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'time-off-leave-overview-create': {
    permissionId: 1,
    appId: 4,
    moduleId: TIME_OFF_WEB_DASH_MODULE_ID,
    featureId: 244,
    key: userPermissionContent.feature.time_off_leave_overview_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'time-off-leave-overview-read': {
    permissionId: 4,
    appId: 4,
    moduleId: TIME_OFF_WEB_DASH_MODULE_ID,
    featureId: 244,
    key: userPermissionContent.feature.time_off_leave_overview_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'time-off-leave-overview-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: TIME_OFF_WEB_DASH_MODULE_ID,
    featureId: 244,
    key: userPermissionContent.feature.time_off_leave_overview_edit,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'time-off-requests-feature-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: TIME_OFF_WEB_DASH_MODULE_ID,
    featureId: 245,
    key: userPermissionContent.feature.employee_time_off_requests_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'time-off-requests-feature-create': {
    permissionId: 1,
    appId: 4,
    moduleId: TIME_OFF_WEB_DASH_MODULE_ID,
    featureId: 245,
    key: userPermissionContent.feature.employee_time_off_requests_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'time-off-requests-feature-read': {
    permissionId: 4,
    appId: 4,
    moduleId: TIME_OFF_WEB_DASH_MODULE_ID,
    featureId: 245,
    key: userPermissionContent.feature.employee_time_off_requests_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'time-off-requests-feature-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: TIME_OFF_WEB_DASH_MODULE_ID,
    featureId: 245,
    key: userPermissionContent.feature.employee_time_off_requests_edit,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'time-off-settings-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: TIME_OFF_WEB_DASH_MODULE_ID,
    featureId: 246,
    key: userPermissionContent.feature.time_off_settings_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'time-off-settings-create': {
    permissionId: 1,
    appId: 4,
    moduleId: TIME_OFF_WEB_DASH_MODULE_ID,
    featureId: 246,
    key: userPermissionContent.feature.time_off_settings_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'time-off-settings-read': {
    permissionId: 4,
    appId: 4,
    moduleId: TIME_OFF_WEB_DASH_MODULE_ID,
    featureId: 246,
    key: userPermissionContent.feature.time_off_settings_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'time-off-settings-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: TIME_OFF_WEB_DASH_MODULE_ID,
    featureId: 246,
    key: userPermissionContent.feature.time_off_settings_edit,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};

export const merchantReportModulePermission = {
  'merchant-report-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 70,
    featureId: 240,
    key: userPermissionContent.feature.merchant_report_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'merchant-report-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 70,
    featureId: 240,
    key: userPermissionContent.feature.merchant_report_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'merchant-report-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 70,
    featureId: 240,
    key: userPermissionContent.feature.merchant_report_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'merchant-report-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 70,
    featureId: 240,
    key: userPermissionContent.feature.merchant_report_edit,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'merchant-report-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 70,
    featureId: 240,
    key: userPermissionContent.feature.merchant_report_delete,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};

export const thirdPartyReportModulePermission = {
  'third-party-order-report-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 70,
    featureId: 238,
    key: userPermissionContent.feature.third_party_order_report_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'third-party-order-report-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 70,
    featureId: 238,
    key: userPermissionContent.feature.third_party_order_report_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'third-party-order-report-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 70,
    featureId: 238,
    key: userPermissionContent.feature.third_party_order_report_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'third-party-order-report-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 70,
    featureId: 238,
    key: userPermissionContent.feature.third_party_order_report_edit,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'third-party-order-report-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 70,
    featureId: 238,
    key: userPermissionContent.feature.third_party_order_report_delete,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};

export const refundReportModulePermission = {
  'refund-report-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 70,
    featureId: 237,
    key: userPermissionContent.feature.refund_report_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'refund-report-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 70,
    featureId: 237,
    key: userPermissionContent.feature.refund_report_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'refund-report-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 70,
    featureId: 237,
    key: userPermissionContent.feature.refund_report_edit,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'refund-report-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 70,
    featureId: 237,
    key: userPermissionContent.feature.refund_report_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'refund-report-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 70,
    featureId: 237,
    key: userPermissionContent.feature.refund_report_delete,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};

// Deals Report permissions - separate object (ID 231) to avoid affecting old migrations
export const dealsReportModulePermission = {
  'deals-report-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 70,
    featureId: 231,
    key: userPermissionContent.feature.deals_report_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'deals-report-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 70,
    featureId: 231,
    key: userPermissionContent.feature.deals_report_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'deals-report-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 70,
    featureId: 231,
    key: userPermissionContent.feature.deals_report_edit,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'deals-report-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 70,
    featureId: 231,
    key: userPermissionContent.feature.deals_report_delete,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};

// Gift Card Report permissions - separate object (ID 229) to avoid affecting old migrations
export const giftCardReportModulePermission = {
  'gift-card-report-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 70,
    featureId: 229,
    key: userPermissionContent.feature.gift_card_report_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'gift-card-report-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 70,
    featureId: 229,
    key: userPermissionContent.feature.gift_card_report_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'gift-card-report-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 70,
    featureId: 229,
    key: userPermissionContent.feature.gift_card_report_edit,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'gift-card-report-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 70,
    featureId: 229,
    key: userPermissionContent.feature.gift_card_report_delete,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};

export const discountReportModulePermission = {
  'discount-report-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 70,
    featureId: 241,
    key: userPermissionContent.feature.discount_report_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'discount-report-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 70,
    featureId: 241,
    key: userPermissionContent.feature.discount_report_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'discount-report-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 70,
    featureId: 241,
    key: userPermissionContent.feature.discount_report_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'discount-report-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 70,
    featureId: 241,
    key: userPermissionContent.feature.discount_report_edit,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'discount-report-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 70,
    featureId: 241,
    key: userPermissionContent.feature.discount_report_delete,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};

export const menuBoardModule = {
  'menu-board-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 69,
    featureId: null,
    key: 'menu-board-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'playlists-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 69,
    featureId: 203,
    key: 'playlists-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'playlists-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 69,
    featureId: 203,
    key: 'playlists-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'playlists-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 69,
    featureId: 203,
    key: 'playlists-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'playlists-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 69,
    featureId: 203,
    key: 'playlists-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'playlists-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 69,
    featureId: 203,
    key: 'playlists-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'screens-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 69,
    featureId: 198,
    key: 'screens-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'screens-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 69,
    featureId: 198,
    key: 'screens-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'screens-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 69,
    featureId: 198,
    key: 'screens-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'screens-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 69,
    featureId: 198,
    key: 'screens-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'screens-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 69,
    featureId: 198,
    key: 'screens-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};

export const AppsPermissions = {
  'mom-visible': {
    permissionId: 5,
    appId: 1,
    moduleId: null,
    featureId: null,
    key: 'mom-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.APP,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'pos-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: null,
    featureId: null,
    key: 'pos-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.APP,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'mpos-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: null,
    featureId: null,
    key: 'mpos-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.APP,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'web-dash-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: null,
    featureId: null,
    key: 'web-dash-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.APP,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};

export const cateringModulePermission = {
  'catering-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 73,
    featureId: null,
    key: 'catering-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'dashboard-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 73,
    featureId: 218,
    key: 'dashboard-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'dashboard-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 73,
    featureId: 218,
    key: 'dashboard-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'dashboard-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 73,
    featureId: 218,
    key: 'dashboard-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'dashboard-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 73,
    featureId: 218,
    key: 'dashboard-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'dashboard-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 73,
    featureId: 218,
    key: 'dashboard-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'invoice-management-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 73,
    featureId: 219,
    key: 'invoice-management-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'invoice-management-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 73,
    featureId: 219,
    key: 'invoice-management-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'invoice-management-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 73,
    featureId: 219,
    key: 'invoice-management-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'invoice-management-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 73,
    featureId: 219,
    key: 'invoice-management-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'invoice-management-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 73,
    featureId: 219,
    key: 'invoice-management-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'package-configuration-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 73,
    featureId: 220,
    key: 'package-configuration-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'package-configuration-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 73,
    featureId: 220,
    key: 'package-configuration-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'package-configuration-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 73,
    featureId: 220,
    key: 'package-configuration-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'package-configuration-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 73,
    featureId: 220,
    key: 'package-configuration-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'package-configuration-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 73,
    featureId: 220,
    key: 'package-configuration-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'email-templates-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 73,
    featureId: 221,
    key: 'email-templates-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'email-templates-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 73,
    featureId: 221,
    key: 'email-templates-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'email-templates-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 73,
    featureId: 221,
    key: 'email-templates-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'email-templates-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 73,
    featureId: 221,
    key: 'email-templates-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'email-templates-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 73,
    featureId: 221,
    key: 'email-templates-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'payment-configuration-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 73,
    featureId: 248,
    key: 'payment-configuration-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'payment-configuration-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 73,
    featureId: 248,
    key: 'payment-configuration-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'payment-configuration-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 73,
    featureId: 248,
    key: 'payment-configuration-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'payment-configuration-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 73,
    featureId: 248,
    key: 'payment-configuration-edit',
    isGranted: true,

    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'payment-configuration-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 73,
    featureId: 248,
    key: 'payment-configuration-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'calendar-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 73,
    featureId: 249,
    key: 'calendar-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'calendar-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 73,
    featureId: 249,
    key: 'calendar-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'calendar-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 73,
    featureId: 249,
    key: 'calendar-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'calendar-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 73,
    featureId: 249,
    key: 'calendar-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'calendar-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 73,
    featureId: 249,
    key: 'calendar-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'email-inbox-visible': {
    permissionId: 5,
    appId: 4,
    moduleId: 73,
    featureId: 250,
    key: 'email-inbox-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'email-inbox-create': {
    permissionId: 1,
    appId: 4,
    moduleId: 73,
    featureId: 250,
    key: 'email-inbox-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'email-inbox-read': {
    permissionId: 4,
    appId: 4,
    moduleId: 73,
    featureId: 250,
    key: 'email-inbox-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'email-inbox-edit': {
    permissionId: 2,
    appId: 4,
    moduleId: 73,
    featureId: 250,
    key: 'email-inbox-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'email-inbox-delete': {
    permissionId: 3,
    appId: 4,
    moduleId: 73,
    featureId: 250,
    key: 'email-inbox-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
